require('/opt/odin/app/frontend/pages/landing_playground/index/index.module.scss');module.exports = "../../app/views/tms/landing_playground/index.html.erb";